/**
 * Service worker registration.
 *
 * This is what makes ZIvapp installable on a phone home screen and able to
 * open offline.
 *
 * Reminder: service workers only run over HTTPS (localhost is exempt). Over a
 * plain LAN address such as http://192.168.1.50:5173 none of this runs, which
 * is why phone testing goes through a tunnel. See docs/SETUP.md.
 */

import { registerSW } from 'virtual:pwa-register'

let updateApp = null

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return

  updateApp = registerSW({
    /*
     * With registerType 'autoUpdate' the new worker takes over by itself
     * on the next load, so there is nothing to prompt for. This stays to
     * announce it — the event is still a useful hook for a banner later.
     *
     * It used to be 'prompt' with nothing listening, so a phone kept the
     * build it first installed and every fix looked unshipped.
     */
    onNeedRefresh() {
      console.info('[ZIvapp] a new build is active from the next load')
      window.dispatchEvent(new CustomEvent('ziv:update-available'))
    },
    onOfflineReady() {
      console.info('[ZIvapp] ready to work offline')
      window.dispatchEvent(new CustomEvent('ziv:offline-ready'))
    },
    onRegisterError(error) {
      console.error('[ZIvapp] service worker registration failed:', error)
    }
  })
}

/** Activate a waiting update and reload. */
export function applyUpdate() {
  updateApp?.(true)
}
